import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "./Our_Associates.css";
import { Link } from "react-router-dom";

const jtgLogo = "/assets/images/home/our_associates/jtg.png";
const minfyLogo = "/assets/images/home/our_associates/minfy.png";
const techMahindra = "/assets/images/home/our_associates/mahindra.png";
const hclLogo = "/assets/images/home/our_associates/hcl.png";
const butterflyLogo = "/assets/images/home/our_associates/butterfly.png";
const chiefexLogo = "/assets/images/home/our_associates/chiefex.png";
const cybrainLogo = "/assets/images/home/our_associates/cybrain.png";
const dyninnoLogo = "/assets/images/home/our_associates/dyninno.png";
const eclerxLogo = "/assets/images/home/our_associates/eclerx.png";
const exatechLogo = "/assets/images/home/our_associates/exatech.png";
const genpactLogo = "/assets/images/home/our_associates/genpact.png";
const grapcityLogo = "/assets/images/home/our_associates/grapcity.png";
const jabilLogo = "/assets/images/home/our_associates/jabil.png";

const pairs = [
  { top: jtgLogo, bottom: minfyLogo },
  { top: techMahindra, bottom: hclLogo },
  { top: butterflyLogo, bottom: chiefexLogo },
  { top: cybrainLogo, bottom: dyninnoLogo },
  { top: eclerxLogo, bottom: exatechLogo },
  { top: chiefexLogo, bottom: genpactLogo },
  { top: grapcityLogo, bottom: jabilLogo },
];

const Our_Associates = () => {
  return (
    <section className="recruiters-section " id="recruiters">
      <div className="container">
        <div className="recruiters_div">
          <div className="widget-title text-center mb-md-4 mb-4">
            <h3 className="associate_title">
              Our <span>Associates / Recruiters</span>
            </h3>
          </div>

          <Swiper
            modules={[Navigation, Autoplay]}
            spaceBetween={20}
            slidesPerView={5}
            loop
            autoplay={{ delay: 3000, disableOnInteraction: false }}
            navigation={{
              prevEl: ".recruiter-prev",
              nextEl: ".recruiter-next",
            }}
            breakpoints={{
              0: {
                slidesPerView: 2,
                spaceBetween: 5,
              },
              450: {
                slidesPerView: 2.8,
                spaceBetween: 10,
              },
              576: { slidesPerView: 3 },
              768: { slidesPerView: 3.8 },
              992: { slidesPerView: 4 },
              1200: { slidesPerView: 5 },
            }}
            className="recruiter-swiper pt-3"
          >
            {pairs.map((pair, idx) => (
              <SwiperSlide key={idx}>
                <div className="recruiter_box">
                  <div className="text-center">
                    <div className="rec_img">
                      <img src={pair.top} alt="" className="img-fluid" />
                    </div>
                  </div>
                  <div className="text-center mt-2">
                    <div className="rec_img">
                      <img src={pair.bottom} alt="" className="img-fluid" />
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

          <div className="recruiter-prev custom-arrow">
            <div className="fa-icon fa-solid fa-angle-left"></div>
          </div>
          <div className="recruiter-next custom-arrow">
            <div className="fa-icon fa-solid fa-angle-right"></div>
          </div>
        </div>
      </div>

      <div className="d-flex justify-content-center mt-4">
        <Link
          to="/"
          className="common_btn"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        >
          Start Your Application
        </Link>
      </div>
    </section>
  );
};

export default Our_Associates;
